var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.menu),function(group){return _c('div',{key:group.title,staticClass:"menu-group"},[_c('h2',{staticClass:"group-title"},[_vm._v(" "+_vm._s(group.title)+" ")]),_c('ul',_vm._l((group.items),function(item){return _c('li',{key:item.name,staticClass:"item-container"},[_c('MenuItem',{attrs:{"item":item}})],1)}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }